export default {
    gruposProduto: [],
    grupoProduto: {},
    subGruposProduto: [],
    subGrupoProduto: {}
}